import React from 'react';

export const Shirt = (props: { className?: string }) => {
    return (
        <svg
            className={props.className}
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M19 4.05151V19.1111C19 19.6121 18.8156 20.0925 18.4874 20.4468C18.1592 20.801 17.7141 21 17.25 21H6.75C6.28587 21 5.84075 20.801 5.51256 20.4468C5.18437 20.0925 5 19.6121 5 19.1111V4M20 12H22C22.5523 12 23 11.5523 23 11V5C23 4.44772 22.5523 4 22 4L6 4M4 12H2C1.44772 12 1 11.5523 1 11L1 5C1 4.44772 1.44772 4 2 4L6.5 4M9.75 4H14.25C14.6642 4 15 4.44772 15 5V7C15 7.55229 14.6642 8 14.25 8H9.75C9.33579 8 9 7.55229 9 7V5C9 4.44772 9.33579 4 9.75 4Z'
                stroke='currentColor'
                stroke-width='2'
                stroke-linecap='round'
                stroke-linejoin='round'
            />
        </svg>
    );
};

export default Shirt;
